module.exports = __webpack_public_path__ + "img/ipad-prepack.fab86040.png";